import gql from 'graphql-tag';

// URL history of some projects plus their current public path and group (from
// item_lookup) so the dashboard can drop rows from previous groups
// (cross-group move = fresh analytics, spec R3).
export default gql`
  query getProjectUrlHistory($projectIds: [Int!]!) {
    project_url_history(
      where: { project_id: { _in: $projectIds } }
      order_by: { first_seen: asc }
    ) {
      project_id
      group_id
      slug_path
      first_seen
      last_seen
    }
    item_lookup(where: { project_id: { _in: $projectIds }, page_id: { _is_null: true } }) {
      project_id
      group_id
      slug_path
    }
  }
`;
